import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pr_switch_wrap lng_dropdown"
}
const _hoisted_2 = { class: "cart_extra" }
const _hoisted_3 = { class: "cart-product-quantity" }
const _hoisted_4 = { class: "product_price" }
const _hoisted_5 = { class: "price" }
const _hoisted_6 = { class: "product__warning" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormControlSelect = _resolveComponent("FormControlSelect")!
  const _component_QuantityBreaks = _resolveComponent("QuantityBreaks")!
  const _component_FormControlQuantity = _resolveComponent("FormControlQuantity")!
  const _component_BuyButton = _resolveComponent("BuyButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.product.hasVariants)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_FormControlSelect, {
            options: _ctx.variants,
            onChange: _ctx.onSelectVariant,
            class: "select__container--border"
          }, null, 8, ["options", "onChange"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.product.quantityBreaks)
      ? _withDirectives((_openBlock(), _createBlock(_component_QuantityBreaks, {
          key: 1,
          group: _ctx.product.quantityBreaks,
          productUnitType: _ctx.displayedWeight
        }, null, 8, ["group", "productUnitType"])), [
          [_vShow, !_ctx.hidePrices]
        ])
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_FormControlQuantity, {
          modelValue: _ctx.quantity,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.quantity) = $event)),
          minimumBuyableAmount: _ctx.product.minimumBuyableAmount,
          maximumBuyableAmount: _ctx.product.maximumBuyableAmount,
          unitType: _ctx.product.unitType
        }, null, 8, ["modelValue", "minimumBuyableAmount", "maximumBuyableAmount", "unitType"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.currentDisplayedPrice ? _ctx.currentDisplayedPrice : _ctx.showPricesAsB2b ? _ctx.product.price + "/" + _ctx.displayedWeight : _ctx.product.priceIncVat + "/" + _ctx.displayedWeight), 1)
      ], 512), [
        [_vShow, !_ctx.hidePrices]
      ])
    ]),
    _createVNode(_component_BuyButton, {
      isLoading: _ctx.isLoading,
      displaySuccess: _ctx.displaySuccess,
      disabled: "",
      onOnClick: _ctx.onBuyButtonClick
    }, null, 8, ["isLoading", "displaySuccess", "onOnClick"]),
    _createElementVNode("div", _hoisted_6, [
      (!_ctx.canCombineProducts())
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t("Cart.FailedToCombineProducts")), 1))
        : _createCommentVNode("", true),
      (_ctx.product && _ctx.product.maximumBuyableAmount && _ctx.quantity >= _ctx.product.maximumBuyableAmount)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.product.maximumBuyableAmount) + " " + _toDisplayString(_ctx.$t("Cart.ReachedMaxQuantity")), 1))
        : _createCommentVNode("", true)
    ])
  ], 64))
}